import { render, staticRenderFns } from "./ConfigurarColumnas.vue?vue&type=template&id=64b00eec&scoped=true&"
import script from "./ConfigurarColumnas.vue?vue&type=script&lang=js&"
export * from "./ConfigurarColumnas.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurarColumnas.vue?vue&type=style&index=0&id=64b00eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b00eec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBreadcrumbs,VBtn,VCardActions,VCardText,VCardTitle,VContainer,VFlex,VIcon,VLayout,VSelect,VSpacer,VSwitch})
